(() => {
  const root = document.querySelector("[data-bv-hero]");
  if (!root) return;

  const slides = Array.from(root.querySelectorAll(".bv-hero__slide"));
  if (slides.length <= 1) return;

  const btnPrev = root.querySelector("[data-bv-prev]");
  const btnNext = root.querySelector("[data-bv-next]");
  const interval = Number(root.dataset.interval) || 5000;

  let idx = 0;
  let timer = null;

  const show = (n) => {
    slides[idx].classList.remove("is-active");
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add("is-active");
  };

  const start = () => {
    stop();
    timer = setInterval(() => show(idx + 1), interval);
  };

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  btnPrev?.addEventListener("click", () => { show(idx - 1); start(); });
  btnNext?.addEventListener("click", () => { show(idx + 1); start(); });

  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);

  start();
})();
